<style src="./EventDetail.scss" lang="scss" scoped></style>
<template>
  <section class="event-detail">
    <content-header path="Cadastro"/>

    <ul class="card-list-container">
      <li
        class="card-list-item size-200x400"
        @click="openEventToAssociateItems()"
        v-if="$store.getters['Login/HAS_PERMISSION_IN_AREA']({area: 'record-user', action: 'SHOW'})">
        <icon-associate-item />
        <h3>Associar Items</h3>
      </li>

      <li
        class="card-list-item size-200x400"
        @click="openBidMirror"
        v-if="$store.getters['Login/HAS_PERMISSION_IN_AREA']({area: 'occupation', action: 'SHOW'})">

        <icon-menu-proposal />
        <h3>Espelho do Edital</h3>
      </li>

      <li
        class="card-list-item size-200x400"
        @click="exportEvent"
        v-if="$store.getters['Login/HAS_PERMISSION_IN_AREA']({area: 'record-client', action: 'SHOW'})">
        <icon-menu-client />
        <h3>Exportar</h3>
      </li>
      <li
        class="card-list-item size-200x400"
        @click="exportMap"
        v-if="$store.getters['Login/HAS_PERMISSION_IN_AREA']({area: 'permission', action: 'SHOW'})">

        <icon-menu-excel-sheet />
        <h3>Criar MAPA</h3>
      </li>
      <li
        class="card-list-item size-200x400"
        @click="openEventProposal"
        v-if="$store.getters['Login/HAS_PERMISSION_IN_AREA']({area: 'occupation', action: 'SHOW'})">

        <icon-menu-proposal />
        <h3>Gerar Proposta</h3>
      </li>

      <li
        class="card-list-item size-200x400"
        @click="generateRMSPackage"
        v-if="$store.getters['Login/HAS_PERMISSION_IN_AREA']({area: 'occupation', action: 'SHOW'})">

        <icon-anvisa-rms />
        <h3>Baixar Registros</h3>

        <div class="progressbar-container">
          <progress-bar
            class="progress-bar"
            v-show="downloadStatus === 'inprogress'"
            :progress="downloadPercent" />
        </div>
      </li>

      <li
        class="card-list-item size-200x400"
        @click="openDocuments"
        v-if="$store.getters['Login/HAS_PERMISSION_IN_AREA']({area: 'occupation', action: 'SHOW'})">

        <icon-anvisa-rms />
        <h3>Documentos</h3>
      </li>

      <li
        class="card-list-item size-200x400"
        @click="openRms"
        v-if="$store.getters['Login/HAS_PERMISSION_IN_AREA']({area: 'occupation', action: 'SHOW'})">

        <icon-anvisa-rms />
        <h3>RMS</h3>
      </li>

      <li
        class="card-list-item size-200x400"
        @click="openEventResult"
        v-if="$store.getters['Login/HAS_PERMISSION_IN_AREA']({area: 'occupation', action: 'SHOW'})">

        <icon-result />
        <h3>Resultado do Evento</h3>
      </li>

      <li
        class="card-list-item size-200x400"
        @click="openEventToQuote"
        v-if="$store.getters['Login/HAS_PERMISSION_IN_AREA']({area: 'occupation', action: 'SHOW'})">

        <icon-quote-item />
        <h3>Cotar com Fornecedor</h3>
      </li>

      <li
        class="card-list-item size-200x400"
        @click="openEventMap"
        v-if="$store.getters['Login/HAS_PERMISSION_IN_AREA']({area: 'occupation', action: 'SHOW'})">

        <icon-quote-item />
        <h3>Mapa</h3>
      </li>

      <li
        class="card-list-item size-200x400"
        @click="openItemPricing"
        v-if="$store.getters['Login/HAS_PERMISSION_IN_AREA']({area: 'occupation', action: 'SHOW'})">

        <icon-quote-item />
        <h3>Precificação de Itens</h3>
      </li>
    </ul>
  </section>
</template>

<script>
import ContentHeader from '@/components/foundation/content-header/ContentHeader'
import { IconAssociateItem,
        IconQuoteItem,
        IconMenuClient,
        IconMenuExcelSheet,
        IconMenuProposal,
        IconAnvisaRms,
        IconMenuPermission,
        IconResult } from '@/components/primitives/icons'
import { ProgressBar } from '@/components/primitives'
import GenerateImportModel from '@/brain/event-detail/GenerateImportModel'
import GenerateMap from '@/brain/event-detail/GenerateMap'
import { mapGetters } from 'vuex'

export default {
  name: 'EventDetail',
  components: {
    ContentHeader,
    IconAssociateItem,
    IconQuoteItem,
    IconMenuClient,
    IconMenuPermission,
    IconMenuExcelSheet,
    IconMenuProposal,
    IconAnvisaRms,
    IconResult,
    ProgressBar
  },
  data () {
    return {}
  },
  computed: {
    ...mapGetters({
      downloadPercent: 'Rms/LOADED_PERCENT',
      downloadStatus: 'Rms/DOWNLOAD_STATUS'
    })
  },
  mounted () {
    this.$store.commit('Rms/CHANGE_DOWNLOAD_STATUS', 'standby')
  },
  methods: {
    openEventToAssociateItems () {
      const eventInfo = this.$store.getters['Events/GET_EVENT_DETAILS']
      const eventId = eventInfo._id
      this.$store.dispatch('Events/OPEN_EVENT_TO_ASSOCIATE_ITEMS', { eventId, route: this.$router })
    },
    openEventProposal () {
      const eventInfo = this.$store.getters['Events/GET_EVENT_DETAILS']
      const eventId = eventInfo._id
      this.$router.push({ name: 'EventProposal', params: { id: eventId } })
    },
    openEventResult () {
      const eventInfo = this.$store.getters['Events/GET_EVENT_DETAILS']
      const eventId = eventInfo._id
      this.$store.dispatch('Events/OPEN_EVENT_TO_RESULT', { eventId, route: this.$router })
    },
    openEventToQuote () {
      const eventInfo = this.$store.getters['Events/GET_EVENT_DETAILS']
      const eventId = eventInfo._id
      this.$store.dispatch('Events/OPEN_EVENT_TO_QUOTE', { eventId, route: this.$router })
    },
    jumpToRoute (pPath) {
      this.$router.push(pPath)
    },
    exportEvent () {
      const eventId = this.$route.params.id
      GenerateImportModel(eventId)
        .then((response) => {
          const url = window.URL.createObjectURL(new Blob([response]))
          const link = document.createElement('a')
          link.href = url
          link.setAttribute('download', 'MODELO_IMPORTACAO.csv')
          document.body.appendChild(link)
          link.click()
        })
    },
    exportMap () {
      const eventId = this.$store.getters['Events/GET_EVENT_DETAILS']._id
      GenerateMap(eventId)
        .then((response) => {
          const url = window.URL.createObjectURL(new Blob([response]))
          const link = document.createElement('a')
          link.href = url
          link.setAttribute('download', 'MAPA.xlsx')
          document.body.appendChild(link)
          link.click()
        })
    },
    async generateRMSPackage () {
      const eventId = this.$route.params.id
      try {
        const response = await this.$store.dispatch('Rms/EXTRACT_RMS_FROM_LIST', { eventId })
        const newBlob = new Blob([response], {type: 'application/pdf'})

        const data = window.URL.createObjectURL(newBlob)
        var link = document.createElement('a')
        link.href = data
        link.download = 'REGISTROS.pdf'
        link.click()
        setTimeout(() => {
          window.URL.revokeObjectURL(data)
        }, 100)
      } catch (error) {
        this.$toasted.error('Não foi possível gerar o arquivo')
      }
    },
    openBidMirror () {
      const eventInfo = this.$store.getters['Events/GET_EVENT_DETAILS']
      const eventId = eventInfo._id
      this.$router.push({ name: 'BidMirror', params: { eventId } })
    },
    openEventMap () {
      const eventInfo = this.$store.getters['Events/GET_EVENT_DETAILS']
      const eventId = eventInfo._id
      this.$router.push({ name: 'EventMap', params: { eventId } })
    },
    openDocuments () {
      const eventInfo = this.$store.getters['Events/GET_EVENT_DETAILS']
      const eventId = eventInfo._id
      this.$router.push({ name: 'EventDocuments', params: { eventId } })
    },
    openRms () {
      const eventInfo = this.$store.getters['Events/GET_EVENT_DETAILS']
      const eventId = eventInfo._id
      this.$router.push({ name: 'EventRms', params: { eventId } })
    },
    openItemPricing () {
      const eventInfo = this.$store.getters['Events/GET_EVENT_DETAILS']
      const eventId = eventInfo._id
      this.$router.push({ name: 'ItemPricing', params: { eventId } })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/view/event-detail/EventDetail.vue